import React from 'react'
import GettingStartedPage from '../../components/Fundraiser/FundraiserOnboarding/GettingStarted';

const GettingStarted = () => {
  return (
    <GettingStartedPage />
  )
}

export default GettingStarted;